import { useLayoutEffect } from "react";
import { App } from "antd";

import { bindNotifications } from "../../utils/notifications";

function NotificationsBridge() {
  const { message } = App.useApp();

  useLayoutEffect(() => bindNotifications(message), [message]);

  return null;
}

export default NotificationsBridge;
